import { Card, CardContent, Skeleton, Box } from "@mui/material";

const ChartSkeleton = ({ height = 300 }) => {
  return (
    <Card
      sx={{
        backgroundColor: "#fff",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e5e7eb",
      }}
    >
      <CardContent>
        <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />

        <Box sx={{ position: "relative" }}>
          <Skeleton variant="rectangular" height={height} sx={{ borderRadius: 2 }} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartSkeleton;
